import { createContext } from "react";

interface LoggedInUserContextI {
  data: Item<Root> | undefined;
  getRootLink: (rel: string) => Link | undefined;
}

const LoggedInUserContext = createContext<LoggedInUserContextI>({
  data: undefined,
  getRootLink: () => undefined,
});

export default LoggedInUserContext;
